<form [formGroup]="multiplePhoneNumber" (ngSubmit)="submit()">
  @if ((currentStep | async) === stepType.FindNumbers) {
  <div class="quantity">
    <div class="mat-body-1 m-b-12">How many numbers? (20 max per request)</div>
    <mat-form-field appearance="outline">
      <mat-select formControlName="quantity">
        @for (number of quantityArray; track number) {
        <mat-option [value]="number">
          {{ number }}
        </mat-option>
        }
      </mat-select>
      <mat-error>Number is required</mat-error>
    </mat-form-field>
  </div>
  <div class="npa">
    <div class="mat-body-1 m-b-12">
      {{ "ONSIP_I18N.CHOOSE_AREA_CODE" | translate }}
      <mat-icon
        [matTooltip]="
          'Please note that we cannot guarantee multiple phone numbers or blocks of sequential numbers in your chosen area code(s).'
        "
        matTooltipClass="onsip-tooltip-background"
        matTooltipPosition="above"
      >
        help_outline
      </mat-icon>
    </div>
    <mat-form-field appearance="outline">
      <mat-select formControlName="npa">
        @for (npaNxx of npaNxxs; track npaNxx) {
        <mat-option [value]="npaNxx.num">
          {{ getNpaDescription(npaNxx) | titlecase }} - {{ npaNxx.num }}
        </mat-option>
        }
      </mat-select>
      <mat-error>Area code is required</mat-error>
    </mat-form-field>
  </div>
  <div class="nxx">
    <div class="mat-body-1 m-b-12">
      Choose local prefix (optional)
      <mat-icon
        [matTooltip]="
          'ONSIP_I18N.ALSO_CALLED_A_RATE_CENTER_OR_EXCHANGE_CODE_THIS_IS_THE_FIRST_THREE_DIGITS_OF_A_STANDARD_SEVENDIGIT_PHONE_NUMBER'
            | translate
        "
        matTooltipClass="onsip-tooltip-background"
        matTooltipPosition="above"
      >
        help_outline
      </mat-icon>
    </div>
    <mat-form-field appearance="outline">
      <mat-select formControlName="nxx">
        @for (nxx of nxxs; track nxx) {
        <mat-option [value]="nxx.num">
          {{ (nxx.rateCenter ? nxx.rateCenter : ("ONSIP_I18N.UNKNOWN" | translate)) | titlecase }}
          - {{ nxx.num }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  } @if ((currentStep | async) === stepType.SearchingNumbers) {
  <div class="spinner">
    <mat-spinner [diameter]="spinnerDiameter"></mat-spinner>
  </div>
  } @if ((currentStep | async) === stepType.SelectNumbers) {
  <span class="available-numbers mat-body-2">
    We found {{ listOfAvailableNumbers.length }} number{{
      listOfAvailableNumbers.length !== 1 ? "s" : ""
    }}. Click "Next" to purchase.
  </span>
  <div class="selected-list">
    <mat-list>
      @if (listOfAvailableNumbers.length) { @for (number of listOfAvailableNumbers; track number) {
      <mat-list-item>
        <span>{{ number.name | e164 }}</span>
      </mat-list-item>
      } } @else {
      <mat-list-item>
        <span>No Phone numbers selected</span>
      </mat-list-item>
      }
    </mat-list>
  </div>
  } @if ((currentStep | async) === stepType.PurchaseNumbers) { @if (!purchasingFlag) {
  <span class="monthly-cost">
    You have chosen to purchase the following {{ listOfAvailableNumbers.length }} number{{
      listOfAvailableNumbers.length !== 1 ? "s" : ""
    }}.
    <b
      >Your account will be charged a ${{ listOfAvailableNumbers.length * setupCost }} one-time
      setup fee and ${{ listOfAvailableNumbers.length * monthlyCost }}/month</b
    >
  </span>
  <div class="selected-list">
    <mat-list>
      @if (listOfAvailableNumbers.length) { @for (number of listOfAvailableNumbers; track number) {
      <mat-list-item>
        <span>{{ number.name | e164 }}</span>
      </mat-list-item>
      } } @else {
      <mat-list-item>
        <span>No Phone numbers selected</span>
      </mat-list-item>
      }
    </mat-list>
  </div>
  } @else {
  <div class="spinner">
    <mat-spinner [diameter]="spinnerDiameter"></mat-spinner>
  </div>
  } }
  <div class="page-view-controls">
    <button mat-button type="button" class="cancel" color="primary" (click)="closeAddNumberForm()">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
    @if ((currentStep | async) === stepType.FindNumbers) {
    <button (click)="navigateToSearch()" mat-flat-button type="button" color="primary">
      Find numbers
    </button>
    } @if ((currentStep | async) === stepType.SelectNumbers) {
    <button (click)="navigateToPurchase()" mat-flat-button type="button" color="primary">
      {{ "ONSIP_I18N.NEXT" | translate }}
    </button>
    } @if ((currentStep | async) === stepType.PurchaseNumbers && !purchasingFlag) {
    <button type="submit" mat-flat-button color="primary">Purchase</button>
    }
  </div>
</form>
